import type { BackOfficeCatalog } from './es'

export const ca = {
  'app.name': 'Eklevo',
  'app.panel': "Panell d'administració",
  'app.title': "Eklevo · Panell d'administració",
  'common.language': 'Idioma',
  'common.loading': 'Carregant…',
  'common.retry': 'Torna-ho a provar',
  'common.cancel': 'Cancel·la',
  'common.close': 'Tanca',
  'common.filters.clear': 'Treu els filtres',
  'common.error.organizationChanged':
    'Has obert una altra empresa en una altra pestanya, i el panell treballa amb una sola alhora. Torna a obrir aquesta per continuar.',
  'common.signOut': 'Tanca la sessió',
  'common.error.generic': "Alguna cosa no ha anat bé. Torna-ho a provar d'aquí a uns minuts.",
  'common.error.rateLimited':
    'Has fet massa peticions seguides. Espera un minut i torna-ho a provar.',
  'common.notFound.title': 'Pàgina no trobada',
  'common.notFound.body': 'La pàgina que busques no existeix.',
  'common.notFound.action': "Ves a l'inici",
  'footer.rights': "© {year} Eklevo. Ús exclusiu de l'equip d'Eklevo.",
  'footer.help': 'Ajuda',

  'signIn.title': "Entra al panell d'administració",
  'signIn.intro':
    "Només per a l'equip d'Eklevo. T'enviarem un enllaç al correu i, després, et demanarem la teva clau d'accés.",
  'signIn.emailLabel': "Correu d'Eklevo",
  'signIn.submit': "Envia'm un enllaç d'accés",
  'signIn.sending': 'Enviant…',
  'signIn.sent':
    "Si el correu és d'una persona de l'equip d'Eklevo, rebràs un enllaç per entrar. Caduca d'aquí a 15 minuts i només es pot fer servir una vegada.",
  'signIn.invalidEmail': 'Escriu un correu vàlid.',
  'signIn.confirm.body':
    "Prem el botó per continuar amb aquest enllaç. Després et demanarem la teva clau d'accés.",
  'signIn.confirm.submit': 'Continua',
  'signIn.confirm.busy': "Comprovant l'enllaç…",
  'signIn.linkInvalid.title': "L'enllaç ha caducat o ja s'ha fet servir",
  'signIn.linkInvalid.body': 'Demana un enllaç nou per entrar.',
  'signIn.linkInvalid.action': 'Demana un enllaç nou',
  'signIn.ended.idle':
    "La sessió s'ha tancat després de 30 minuts sense activitat. Torna a entrar per continuar.",
  'signIn.ended.expired': 'La sessió ha arribat al màxim de 8 hores. Torna a entrar per continuar.',
  'signIn.ended.closed':
    "La sessió s'ha tancat: has entrat des d'un altre dispositiu o s'ha tancat des de l'eina d'operador. Torna a entrar per continuar.",
  'signIn.ended.signedOut': 'Has tancat la sessió.',

  'passkey.title': 'Confirma que ets tu',
  'passkey.body': "Fes servir la teva clau d'accés: l'empremta, la cara o el PIN del dispositiu.",
  'passkey.submit': "Fes servir la meva clau d'accés",
  'passkey.busy': "Esperant la teva clau d'accés…",
  'passkey.lost.summary': "Has perdut la clau d'accés?",
  'passkey.lost.body':
    "Demana un permís de registre nou a la persona responsable tècnica d'Eklevo: esborrarà les teves claus anteriors i en podràs registrar una de nova durant una hora. No hi ha cap altra manera d'entrar.",
  'enroll.title': "Registra la teva clau d'accés",
  'enroll.body':
    "Per entrar al panell necessites una clau d'accés. Es desbloqueja amb l'empremta, la cara o el PIN del dispositiu, i Eklevo no desa cap contrasenya: només la part pública de la clau.",
  'enroll.hint':
    "Et recomanem tenir-ne dues, la de l'ordinador i la del mòbil. La segona la podràs afegir un cop dins.",
  'enroll.submit': "Crea la meva clau d'accés",
  'enroll.busy': 'Segueix les instruccions del dispositiu…',
  'enroll.done.title': "Clau d'accés registrada",
  'enroll.done.body': 'Ara fes-la servir per entrar.',
  'enroll.done.submit': "Entra amb la meva clau d'accés",
  'enrollmentRequired.title': "Encara no tens cap clau d'accés",
  'enrollmentRequired.body':
    "Per registrar la primera necessites un permís de l'eina d'operador, que dura una hora. Demana'l a la persona responsable tècnica d'Eklevo i, quan el tinguis, prem «Ja tinc el permís».",
  'enrollmentRequired.check': 'Ja tinc el permís',
  'enrollmentRequired.stillMissing': 'Encara no tens cap permís de registre obert.',

  'webauthn.cancelled':
    "No s'ha fet servir cap clau: s'ha cancel·lat o ha trigat massa. Torna-ho a provar.",
  'webauthn.alreadyRegistered':
    "Aquest dispositiu ja té una clau d'accés teva. Fes servir aquesta clau, o crea la nova en un altre dispositiu.",
  'webauthn.unsupported':
    "Aquest navegador no pot fer servir claus d'accés. Fes servir una versió recent de Chrome, Edge, Firefox o Safari.",
  'webauthn.noUserVerification':
    "Aquest dispositiu no pot comprovar que ets tu amb l'empremta, la cara o un PIN. Activa el bloqueig de pantalla o fes servir un altre dispositiu.",
  'webauthn.wrongAddress':
    "Des d'aquesta adreça no es poden fer servir claus d'accés. Obre el panell des de l'adreça de l'enllaç del correu.",
  'webauthn.notRecognized':
    "No hem reconegut aquesta clau d'accés. Prova-ho amb una altra de les teves claus; si no en tens cap, demana un permís de registre nou.",
  'webauthn.tooManyAttempts':
    "Hi ha hagut massa intents fallits durant l'última hora. Espera una estona o demana ajuda a la persona responsable tècnica d'Eklevo.",
  'webauthn.expired': 'La petició ha caducat. Torna-ho a provar.',
  'webauthn.enrollmentNotAllowed':
    "Ja no tens cap permís de registre obert: ha caducat o ja l'has fet servir. Demana'n un de nou.",
  'webauthn.tooManyPasskeys': "Ja tens el màxim de 3 claus d'accés.",
  'webauthn.failed': "No s'ha pogut fer servir la clau d'accés. Torna-ho a provar.",

  'shell.skip': 'Salta al contingut',
  'nav.label': 'Seccions del panell',
  'nav.home': 'Inici',
  'nav.companies': 'Empreses',
  'nav.catalog': 'Cursos',
  'status.organization.active': 'Activa',
  'status.organization.suspended': 'Suspesa',
  'status.program.not_launched': 'No llançat',
  'status.program.active': 'Actiu',
  'status.program.stopped': 'Aturat',
  'status.program.completed': 'Completat',
  'status.course.draft': 'Esborrany',
  'status.course.published': 'Publicat',
  'status.course.archived': 'Arxivat',
  'home.title': 'Inici',
  'home.body':
    "Les empreses d'Eklevo i el seu catàleg de cursos, en recomptes, i l'activitat de l'equip. Cap persona de les empreses.",
  'home.stats.label': 'Indicadors',
  'home.stats.organizations': 'Empreses actives',
  'home.stats.people': 'Persones actives',
  'home.stats.peopleHint': 'De les empreses actives',
  'home.stats.courses': 'Cursos publicats',
  'home.stats.assignments': 'Assignacions en curs',
  'home.stats.assignmentsHint': 'Sense acabar, de les persones de les empreses actives',
  'home.stats.completion': 'Finalització global',
  'home.stats.completionHint': '{count, number} de {total, number} assignacions acabades',
  'home.stats.completionNone': 'Encara no hi ha cap assignació',
  'home.stats.noValue': '—',
  'home.empty.title': 'Encara no hi ha cap empresa activa',
  'home.empty.body':
    "Dona d'alta la primera amb l'assistent: les seves dades, el seu equip de RRHH, el seu avís informatiu i els seus cursos.",
  'home.empty.add': 'Afegeix una empresa nova',
  'home.go.label': 'Accessos ràpids',
  'home.go.companies':
    "Donar d'alta una empresa, editar-la, el seu equip de RRHH, i suspendre-la o reactivar-la.",
  'home.go.catalog': "El catàleg d'Eklevo, i activar un curs en una empresa.",
  'home.access.title': 'El teu accés',
  'home.session.title': 'La teva sessió',
  'home.session.endsAt':
    'Acaba com a molt tard a les {endsAt, time, short}, i abans si passes 30 minuts sense activitat.',
  'home.passkeys.title': "Les teves claus d'accés",
  'home.passkeys.count':
    "{count, plural, one {Tens # clau d'accés, d'un màxim de 3.} other {Tens # claus d'accés, d'un màxim de 3.}}",
  'home.passkeys.hint':
    "Te'n recomanem dues, la de l'ordinador i la del mòbil. Si perds un dispositiu, avisa la persona responsable tècnica d'Eklevo.",
  'home.passkeys.add': "Afegeix una clau d'accés",
  'home.passkeys.createTitle': 'Crea la clau nova',
  'home.passkeys.createBody':
    'Crea-la en aquest dispositiu o, amb el codi QR que et mostri el navegador, al mòbil.',
  'home.passkeys.create': 'Crea la clau nova',
  'home.passkeys.added':
    "{count, plural, one {Clau afegida. Ara tens # clau d'accés.} other {Clau afegida. Ara tens # claus d'accés.}}",
  'home.passkeys.full': "Ja tens el màxim de 3 claus d'accés.",
  'home.activity.title': "Activitat recent de l'equip d'Eklevo",
  'home.activity.body':
    "Les últimes accions de l'equip, al panell i amb l'eina d'operador. Mai les de les persones de les empreses.",
  'home.activity.empty': "Encara no hi ha activitat de l'equip.",
  'home.activity.someone': "Una persona de l'equip",
  'home.activity.at': '{at, date, medium}, {at, time, short}',
  'home.activity.organization.created': "ha donat d'alta {company}.",
  'home.activity.organization.updated': 'ha editat les dades de {company}.',
  'home.activity.organization.brand_set': 'ha canviat la marca de {company}.',
  'home.activity.organization.suspended': 'ha suspès {company}.',
  'home.activity.organization.reactivated': 'ha reactivat {company}.',
  'home.activity.program.activated': 'ha activat «{course}» a {company}.',
  'home.activity.person.invited': "ha reenviat una invitació de l'equip de RRHH de {company}.",
  'home.activity.course.created': 'ha creat el curs «{course}».',
  'home.activity.course.published': 'ha publicat «{course}».',
  'home.activity.course.corrected': 'ha corregit «{course}».',
  'home.activity.course.imported': 'ha carregat una versió de «{course}».',
  'home.activity.course.archived': 'ha arxivat «{course}».',
  'home.activity.course.duplicated': 'ha duplicat un curs a «{course}».',
  'home.activity.untitledCourse': 'Curs sense títol',
  'home.activity.goneCourse': 'Curs que ja no existeix',
  'home.noa.title': 'Noa',
  'home.noa.body':
    "Les empreses que aquest mes han passat del 80 % del seu topall de la Noa, i les que la tenen en pausa. Mai l'import: el dona l'eina d'operador.",
  'home.noa.empty': 'Cap empresa ha passat del 80 % del seu topall ni té la Noa en pausa.',
  'home.noa.warning': "Ha passat del 80 % del seu topall d'aquest mes.",
  'home.noa.paused': 'Ha arribat al seu topall: la Noa està en pausa fins al mes que ve.',
  'home.noa.updating': 'La Noa està en pausa per una actualització: cal tornar a activar-la.',

  'companies.title': 'Empreses',
  'companies.body': 'Nom, estat i recomptes de cada empresa. La llista no mostra cap persona.',
  'companies.add': 'Afegeix una empresa',
  'companies.filters.label': 'Cerca i filtra empreses',
  'companies.search': 'Cerca empreses',
  'companies.filter.status': 'Estat',
  'companies.filter.allStatuses': 'Tots els estats',
  'companies.count': '{count, plural, one {# empresa} other {# empreses}}',
  'companies.empty.title': 'Encara no hi ha cap empresa',
  'companies.empty.body': "Dona d'alta la primera amb «Afegeix una empresa».",
  'companies.noResults': 'Cap empresa no coincideix amb la cerca i el filtre.',
  'companies.open': 'Mostra el detall',
  'companies.openLabel': 'Mostra el detall de {company}',
  'company.counts': 'Recomptes',
  'company.activePeople': 'Persones actives',
  'company.invitedPeople': 'Convidades sense entrar',
  'company.hrPeople': 'Equip de RRHH',
  'company.departments': 'Departaments',
  'company.activeCourses': 'Cursos actius',
  'company.activeCoursesHint':
    "«Cursos actius» compta els que RRHH ja ha llançat; un que s'acaba d'activar queda «No llançat».",
  'company.back': 'Totes les empreses',
  'company.audited':
    "Obrir aquesta fitxa queda al registre d'auditoria de l'empresa, com editar-la, veure'n l'equip de RRHH, reenviar-hi una invitació, suspendre-la, reactivar-la o activar-hi un curs.",
  'company.notFound.title': 'Aquesta empresa no existeix o ja no està disponible',
  'company.notFound.body': "Potser s'ha donat de baixa. Torna a la llista d'empreses.",
  'company.reopen': 'Torna a obrir aquesta empresa',
  'company.courses.title': "Cursos d'Eklevo activats",
  'company.courses.empty': "Encara no té cap curs d'Eklevo activat.",
  'company.courses.toCatalog': 'Activa un curs des de «Cursos»',
  'company.noa.title': 'Noa',
  'company.noa.state.on': 'Activa',
  'company.noa.state.off': 'Desactivada',
  'company.noa.state.updating': 'En pausa per una actualització',
  'company.noa.state.paused': 'En pausa pel topall',
  'company.noa.on': "La Noa respon a les persones de l'empresa.",
  'company.noa.off':
    "La Noa no està activada en aquesta empresa. L'activa l'equip d'Eklevo amb l'eina d'operador, després de la revisió especialista.",
  'company.noa.updating':
    "La Noa funciona ara amb versions diferents de les validades en activar-la en aquesta empresa. Fins que es torni a activar amb les noves, després de passar les frases trampa a l'entorn de proves, només respon el filtre de crisi.",
  'company.noa.paused':
    "Ha arribat al seu topall d'aquest mes: fins al mes que ve només respon el filtre de crisi.",
  'company.noa.warning': 'Aquest mes ha passat del 80 % del seu topall.',
  'company.noa.validated': 'Validada amb',
  'company.noa.running': 'Versions en marxa',
  'company.noa.prompt': 'Prompt',
  'company.noa.crisisTerms': 'Llista de crisi',
  'company.noa.model': 'Model',
  'company.noa.validatedAt': 'Activada',
  'company.noa.at': '{at, date, medium}, {at, time, short}',
  'company.noa.unknown': 'Desconegut',
  'company.noa.amount': "El topall i l'import exactes només els dona l'eina d'operador.",
  'company.passkeyNote': "Et demanarem la teva clau d'accés per confirmar-ho.",
  'company.suspend': 'Suspèn',
  'company.suspend.title': 'Vols suspendre {company}?',
  'company.suspend.body':
    "Totes les persones de l'empresa perden l'accés a Eklevo ara mateix, al portal i a la consola de RRHH, també qui tingui la sessió oberta, i els enllaços d'accés ja enviats deixen de servir. Fins que la reactivis. Les seves dades no canvien.",
  'company.suspend.busy': 'Suspenent…',
  'company.suspended': "Empresa suspesa: ningú de l'empresa no hi pot entrar.",
  'company.reactivate': 'Reactiva',
  'company.reactivate.title': 'Vols reactivar {company}?',
  'company.reactivate.body':
    "Les persones de l'empresa podran tornar a entrar amb un enllaç d'accés, amb tot el que tenien.",
  'company.reactivate.busy': 'Reactivant…',
  'company.reactivated': 'Empresa reactivada: les seves persones ja hi poden tornar a entrar.',
  'company.error.unchanged': "Una altra persona de l'equip ja havia fet aquest canvi.",
  'company.created':
    "{count, plural, =0 {Empresa creada. L'equip de RRHH rebrà la invitació d'aquí a uns minuts.} one {Empresa creada. L'equip de RRHH rebrà la invitació d'aquí a uns minuts, i el curs espera «No llançat» fins que RRHH el llanci.} other {Empresa creada. L'equip de RRHH rebrà la invitació d'aquí a uns minuts, i els cursos esperen «No llançat» fins que RRHH els llanci.}}",
  'company.data.title': "Dades de l'empresa",
  'company.data.locale': 'Idioma per defecte',
  'company.data.timeZone': 'Zona horària',
  'company.data.brand': 'Colors de marca',
  'company.data.brand.none': "Els d'Eklevo",
  'company.data.logo': 'Logotip',
  'company.data.logo.alt': 'Logotip de {company}',
  'company.data.logo.none': 'Sense logotip',
  'company.data.legalName': 'Nom legal',
  'company.data.taxId': 'CIF/NIF',
  'company.data.address': 'Adreça',
  'company.data.privacyContact': 'Contacte de privacitat',
  'company.data.none': 'Sense indicar',
  'company.edit': 'Edita',
  'company.edit.title': "Edita les dades de l'empresa",
  'company.edit.intro':
    "Els canvis es veuen des d'ara al portal i a la consola de RRHH de l'empresa. El nom i la zona horària també compten als correus que surtin i als diplomes que es descarreguin a partir d'ara.",
  'company.edit.legal.hint': 'Opcionals. Si en deixes una en blanc, es treu.',
  'company.edit.save': 'Desa els canvis',
  'company.edit.busy': 'Desant…',
  'company.edit.saved': "Dades de l'empresa desades.",
  'company.edit.purpose': 'Desar els canvis de {company}.',
  'company.edit.unchanged': 'No hi ha cap canvi per desar.',
  'company.edit.problems': 'Revisa els camps marcats.',
  'company.edit.logo.kept': "L'empresa té logotip.",
  'company.edit.logo.removed': 'Es traurà el logotip en desar.',
  'company.edit.logo.undo': 'Mantén el logotip',
  'company.edit.noticeMissing':
    "L'última versió de l'avís informatiu d'aquesta empresa no és en aquest idioma. Publica abans una versió que l'inclogui, amb l'eina d'operador («org notice»), i torna'l a canviar.",
  'company.edit.stale':
    "Una altra persona ha desat canvis a les dades de l'empresa mentre les editaves, i els teus no s'han desat. Aquestes són les dades actuals: torna a «Edita» si les vols canviar.",
  'company.hr.title': 'Equip de RRHH',
  'company.hr.body':
    "Només les persones amb el rol de RRHH, convidades o actives: l'únic lloc del panell amb noms i correus. Cada cop que es mostra queda al registre d'auditoria de l'empresa.",
  'company.hr.empty': "L'empresa no té cap persona de RRHH convidada ni activa.",
  'company.hr.status.active': 'Activa',
  'company.hr.status.invited': 'Convidada',
  'company.hr.invitation.usable': 'Invitació enviada el {at, date, medium}',
  'company.hr.invitation.expired': "L'última invitació, del {at, date, medium}, ja no serveix",
  'company.hr.invitation.none': 'Encara no se li ha enviat cap invitació',
  'company.hr.resend': 'Reenvia la invitació',
  'company.hr.send': 'Envia la invitació',
  'company.hr.resend.busy': 'Enviant…',
  'company.hr.confirm.resend':
    'Li arribarà un correu amb un enllaç nou per entrar, i el de la invitació anterior deixarà de servir. Com a molt 3 al dia per persona.',
  'company.hr.confirm.send':
    'Li arribarà un correu amb un enllaç per entrar. Com a molt 3 al dia per persona.',
  'company.hr.resent':
    "Invitació enviada. Arribarà d'aquí a uns minuts, i l'anterior deixa de servir.",
  'company.hr.noNotice':
    "L'empresa encara no té avís informatiu: no surt cap invitació fins que el tingui.",
  'company.hr.error.limit':
    'Aquesta persona ja ha rebut 3 invitacions avui. Torna-ho a provar demà.',
  'company.hr.error.notInvitable': 'Aquesta persona ja hi ha entrat: no necessita cap invitació.',
  'company.hr.error.notFound': "Aquesta persona ja no és a l'equip de RRHH de l'empresa.",
  'company.hr.suspended': "L'empresa està suspesa: reactiva-la per enviar invitacions.",
  'catalog.title': 'Cursos',
  'catalog.body':
    "El catàleg d'Eklevo. Un curs publicat s'activa empresa per empresa, i queda «No llançat» fins que RRHH el llança.",
  'catalog.filters.label': 'Cerca i filtra cursos',
  'catalog.search': 'Cerca cursos',
  'catalog.filter.level': 'Nivell',
  'catalog.filter.allLevels': 'Tots els nivells',
  'catalog.empty.title': 'Encara no hi ha cap curs al catàleg',
  'catalog.empty.body': "Crea el primer amb «Crea un curs nou», o carrega'l amb l'eina d'operador.",
  'catalog.noResults': 'Cap curs no coincideix amb la cerca i el filtre.',
  'catalog.untitled': 'Curs sense títol',
  'catalog.level': 'Nivell {level}',
  'catalog.lessons': '{count, plural, one {# lliçó} other {# lliçons}}',
  'catalog.duration': '{minutes, number} min',
  'catalog.activeIn':
    '{count, plural, =0 {No és actiu en cap empresa} one {Actiu en # empresa} other {Actiu en # empreses}}',
  'catalog.activeInHint': "Compta les empreses en què RRHH ja l'ha llançat, també les suspeses.",
  'catalog.activate': 'Activa en una empresa',
  'catalog.activate.label': 'Activa en una empresa: {course}',
  'catalog.activate.company': 'Empresa',
  'catalog.activate.choose': 'Tria una empresa',
  'catalog.activate.suspended': '{company} (suspesa)',
  'catalog.activate.hint': "Quedarà «No llançat»: RRHH de l'empresa decideix quan el llança.",
  'catalog.activate.submit': 'Activa',
  'catalog.activate.busy': 'Activant…',
  'catalog.activate.required': 'Tria una empresa.',
  'catalog.activate.done': 'Activat a {company}. Queda «No llançat» fins que RRHH el llanci.',
  'catalog.activate.already': '{company} ja té aquest curs.',
  'catalog.activate.purpose': 'Activar «{course}» a {company}.',
  'catalog.activate.unavailable':
    "Aquest curs ja no es pot activar, o l'empresa ja no està disponible.",
  'catalog.activate.noCompanies': 'Encara no hi ha cap empresa on activar-lo.',
  'catalog.create': 'Crea un curs nou',
  'catalog.edit': 'Edita',
  'catalog.edit.label': 'Edita «{course}»',
  'catalog.duplicate': 'Duplica',
  'catalog.duplicate.label': 'Duplica «{course}»',
  'catalog.duplicate.title': 'Duplicar «{course}»',
  'catalog.duplicate.body.published':
    'Crearem un esborrany nou amb tot el contingut de la versió publicada: lliçons, avaluacions, materials i vídeos. El curs original no canvia.',
  'catalog.duplicate.body.draft':
    "Crearem un esborrany nou amb tot el contingut d'aquest esborrany: lliçons, avaluacions, materials i vídeos. El curs original no canvia.",
  'catalog.duplicate.after':
    "El duplicat no té sèrie ni nivell ni és actiu a cap empresa. T'avisarem aquí quan estigui llest perquè el revisis a l'editor i el publiquis.",
  'catalog.duplicate.busy': 'Duplicant…',
  'catalog.duplicate.unavailable': 'Aquest curs ja no està disponible.',
  'catalog.duplicate.running':
    "Duplicant: s'estan copiant els fitxers, i amb vídeos grans pot trigar uns minuts. Pots continuar treballant; l'esborrany apareixerà a «Cursos».",
  'catalog.duplicate.done': "Duplicat: l'esborrany ja és a «Cursos».",
  'catalog.duplicate.open': "Obre l'esborrany",
  'catalog.duplicate.failed':
    "No s'ha pogut duplicar i no s'ha creat cap esborrany. Torna-ho a provar. Codi: {code}.",
  'catalog.duplicate.unknown':
    'No sabem com ha acabat. Si el duplicat no apareix a «Cursos», torna-ho a provar.',
  'catalog.archive': 'Arxiva',
  'catalog.archive.label': 'Arxiva «{course}»',
  'catalog.archive.checking': 'Comprovant…',
  'catalog.archive.title': 'Arxivar «{course}»',
  'catalog.archive.body':
    "Cap empresa nova no el podrà activar. Un curs arxivat no s'edita ni es pot desarxivar, però sí que es pot duplicar.",
  'catalog.archive.companies':
    '{count, plural, =0 {Cap empresa no el té activat.} one {El té activat # empresa, que ja no el podrà assignar a ningú més.} other {El tenen activat # empreses, que ja no el podran assignar a ningú més.}}',
  'catalog.archive.people':
    '{count, plural, =0 {Ningú no el té assignat sense acabar.} one {# persona el té assignat sense acabar: el podrà acabar amb la seva versió.} other {# persones el tenen assignat sense acabar: el podran acabar amb la seva versió.}}',
  'catalog.archive.draft':
    "Es descartarà l'esborrany obert a l'editor, amb els canvis que no s'han publicat.",
  'catalog.archive.changed':
    'El curs ha canviat mentre ho confirmaves: revisa de nou què passarà en arxivar-lo.',
  'catalog.archive.busy': 'Arxivant…',
  'catalog.archive.done': '«{course}» arxivat. Qui el tenia assignat el pot acabar.',
  'catalog.archive.unavailable': "Aquest curs ja és arxivat o no s'ha publicat mai.",
  'editor.publish.purpose': 'Publicar «{course}» al catàleg.',
  'editor.notFound': 'Aquest curs no existeix o ja no està disponible.',
  'editor.back': 'Torna a Cursos',
  'wizard.title': 'Afegeix una empresa nova',
  'wizard.body':
    "Les dades de l'empresa, el seu equip de RRHH, el seu avís informatiu i els cursos amb què comença. El que escriguis només es guarda en aquesta pestanya fins que creïs l'empresa.",
  'wizard.steps.label': "Passos de l'alta",
  'wizard.step.company': "Dades de l'empresa",
  'wizard.step.people': 'Empleats',
  'wizard.step.hr': 'Equip de RRHH',
  'wizard.step.notice': 'Avís informatiu',
  'wizard.step.courses': 'Cursos',
  'wizard.step.summary': 'Resum',
  'wizard.step.position': 'Pas {step} de {total}',
  'wizard.step.done': 'completat',
  'wizard.step.problems': 'amb dades per revisar',
  'wizard.step.pending': 'pendent',
  'wizard.back': 'Enrere',
  'wizard.next': 'Següent',
  'wizard.cancel': 'Cancel·la',
  'wizard.problems': 'Revisa les dades marcades en aquest pas per continuar.',
  'wizard.problems.server':
    "No s'ha creat l'empresa: hi ha dades per revisar en aquest pas. Corregeix-les i torna a «Crea l'empresa».",
  'wizard.leave.title': "Vols sortir sense crear l'empresa?",
  'wizard.leave.body':
    "Es perdrà el que has escrit: l'alta només es guarda en aquesta pestanya fins que crees l'empresa.",
  'wizard.leave.stay': "Continua amb l'alta",
  'wizard.leave.confirm': 'Surt sense crear-la',
  'wizard.locale.es': 'Castellà',
  'wizard.locale.ca': 'Català',
  'wizard.locale.en': 'Anglès',
  'wizard.timeZone.Europe/Madrid': 'Península i Balears (Europe/Madrid)',
  'wizard.timeZone.Atlantic/Canary': 'Canàries (Atlantic/Canary)',
  'wizard.company.intro':
    'El nom amb què la veuran les seves persones, el seu idioma, la seva zona horària i, si vols, les seves dades legals i els seus colors.',
  'wizard.company.name': "Nom de l'empresa",
  'wizard.company.name.hint': "No pot coincidir amb el d'una altra empresa d'Eklevo.",
  'wizard.company.locale': 'Idioma per defecte',
  'wizard.company.locale.hint':
    'El de les invitacions i el de les persones noves. Cada persona pot canviar el seu.',
  'wizard.company.timeZone': 'Zona horària',
  'wizard.company.timeZone.hint':
    "La de les dates límit, els recordatoris, els diplomes i els informes de l'empresa.",
  'wizard.company.legal': 'Dades legals',
  'wizard.company.legal.hint': "Opcionals: també es poden completar després, des d'«Edita».",
  'wizard.company.legalName': 'Nom legal',
  'wizard.company.legalName.hint': "La raó social, si és diferent del nom de l'empresa.",
  'wizard.company.taxId': 'CIF/NIF',
  'wizard.company.taxId.hint':
    "Un CIF, NIF o NIE espanyol, o un NIF-IVA intracomunitari. L'espanyol es desa sense «ES».",
  'wizard.company.address': 'Adreça',
  'wizard.company.address.hint': "La de la seu de l'empresa, en una línia.",
  'wizard.company.privacyContact': 'Contacte de privacitat',
  'wizard.company.privacyContact.hint':
    "El correu on les seves persones poden escriure sobre les seves dades. Millor una bústia compartida, com privacitat@ o dpd@, que la d'una persona.",
  'wizard.logo': "Logotip de l'empresa",
  'wizard.logo.hint':
    "PNG o JPEG, de fins a 1 MB i entre 32 i 4.000 píxels per costat. Opcional: sense logotip, el portal i la consola mostren el d'Eklevo.",
  'wizard.logo.choose': 'Tria el logotip',
  'wizard.logo.ready': 'Logotip a punt: {file}',
  'wizard.logo.change': 'Canvia el logotip',
  'wizard.logo.remove': 'Treu el logotip',
  'upload.sending': "S'està pujant {file}",
  'upload.percent': '{percent, number, percent}',
  'upload.progress': 'Progrés de la pujada',
  'upload.scanning': "S'està analitzant {file}: revisem que el fitxer sigui segur.",
  'upload.cancel': 'Cancel·la',
  'upload.cancel.label': 'Cancel·la la pujada de {file}',
  'wizard.brand': 'Colors de marca',
  'wizard.brand.use': "Fes servir els colors de l'empresa",
  'wizard.brand.use.hint':
    "Opcional. Sense, el portal i la consola de l'empresa fan servir els d'Eklevo. No es veuen mai en aquest panell ni als correus.",
  'wizard.brand.primary': 'Color principal',
  'wizard.brand.accent': "Color d'accent",
  'wizard.brand.pick.primary': 'Tria el color principal',
  'wizard.brand.pick.accent': "Tria el color d'accent",
  'wizard.brand.hint': 'En format #RRGGBB, com #1b2a4a.',
  'wizard.brand.contrast': 'Contrast',
  'wizard.brand.contrast.intro':
    "Cada ús dels colors s'ha de llegir bé (WCAG 2.2). Uns colors que no compleixen una regla no es poden desar; amb un avís de disseny, sí.",
  'wizard.brand.rule.primary-text': 'Text sobre el color principal',
  'wizard.brand.rule.primary-text-muted': 'Text secundari sobre el color principal',
  'wizard.brand.rule.primary-text-hover': "Text d'un botó principal amb el punter a sobre",
  'wizard.brand.rule.primary-ui': 'Color principal sobre les targetes i el fons',
  'wizard.brand.rule.accent-text': "Text sobre el color d'accent",
  'wizard.brand.rule.accent-text-hover': "Text d'un botó d'accent amb el punter a sobre",
  'wizard.brand.rule.accent-ui-primary': "Botó d'accent sobre el color principal",
  'wizard.brand.rule.accent-ui-surface': "Botó d'accent sobre una targeta blanca",
  'wizard.brand.check.passed': 'Compleix: {ratio} (mínim {minimum})',
  'wizard.brand.check.failed': 'No compleix: {ratio} (mínim {minimum})',
  'wizard.brand.check.warning':
    'Avís de disseny: {ratio}, per sota de {minimum}. Es pot desar: el botó es llegeix pel seu text, però destaca menys.',
  'wizard.people.intro':
    "La llista d'empleats la carrega l'equip de RRHH des de la seva consola, a «Empleats i progrés» › «Importa un CSV», amb aquesta plantilla. Així, les seves dades no passen pel panell d'Eklevo.",
  'wizard.people.columns':
    "Una persona per línia: el correu (obligatori), el nom i els cognoms i, si es vol, el departament, l'equip, el càrrec, la data d'incorporació, l'idioma i el rol.",
  'wizard.people.invitations':
    "Les persones treballadores no reben res en crear l'empresa: RRHH envia les invitacions quan ho decideix.",
  'wizard.people.template': 'Descarrega la plantilla CSV',
  'wizard.people.templateFile': 'plantilla-persones',
  'wizard.hr.heading': 'Designar responsables de RRHH',
  'wizard.hr.intro':
    "Aquestes persones rebran un correu d'invitació a Eklevo. En entrar, també tindran la consola de RRHH.",
  'wizard.hr.person': 'Persona {count}',
  'wizard.hr.firstName': 'Nom',
  'wizard.hr.lastName': 'Cognoms',
  'wizard.hr.email': 'Correu corporatiu',
  'wizard.hr.email.hint':
    "El d'una persona concreta, mai una bústia compartida com rrhh@ o info@: cada acció de RRHH queda a nom de qui la fa.",
  'wizard.hr.add': 'Afegeix una altra persona',
  'wizard.hr.remove': 'Treu',
  'wizard.hr.removeLabel': 'Treu la persona {count}',
  'wizard.hr.max': 'Com a molt, 10 persones aquí; la resta, després, des de la consola de RRHH.',
  'wizard.notice.intro':
    "L'avís informatiu de privacitat de l'empresa: cada persona el veu i confirma que l'ha llegit en el seu primer accés, i el correu d'invitació n'enllaça l'adreça. Sense avís no surt cap invitació.",
  'wizard.notice.legend.es': 'Avís en castellà',
  'wizard.notice.legend.ca': 'Avís en català',
  'wizard.notice.legend.en': 'Avís en anglès',
  'wizard.notice.default': "És l'idioma de l'empresa: aquest avís és obligatori.",
  'wizard.notice.add.es': "Afegeix també l'avís en castellà",
  'wizard.notice.add.ca': "Afegeix també l'avís en català",
  'wizard.notice.add.en': "Afegeix també l'avís en anglès",
  'wizard.notice.format': "Format de l'avís",
  'wizard.notice.format.url': 'Enllaç',
  'wizard.notice.format.text': 'Text',
  'wizard.notice.url': "Adreça de l'avís",
  'wizard.notice.url.hint': "Una pàgina de l'empresa, que comenci per https://.",
  'wizard.notice.body': "Text de l'avís",
  'wizard.notice.body.count': '{count, number}/20.000 caràcters, amb un mínim de 20',
  'wizard.courses.intro':
    "Els cursos del catàleg d'Eklevo amb què comença l'empresa. Queden activats i «No llançat»: RRHH decideix quan els llança i a qui els assigna.",
  'wizard.courses.list': 'Cursos publicats del catàleg',
  'wizard.courses.optional': 'Opcional: també es poden activar després, des de «Cursos».',
  'wizard.courses.count':
    '{count, plural, =0 {Cap curs seleccionat} one {# curs seleccionat} other {# cursos seleccionats}}',
  'wizard.courses.empty':
    'Encara no hi ha cap curs publicat al catàleg. Els podràs activar després, des de «Cursos».',
  'wizard.summary.intro': "Revisa les dades abans de crear l'empresa. Es crea tot alhora, o res.",
  'wizard.summary.edit.company': "Edita les dades de l'empresa",
  'wizard.summary.edit.hr': "Edita l'equip de RRHH",
  'wizard.summary.edit.notice': "Edita l'avís informatiu",
  'wizard.summary.edit.courses': 'Edita els cursos',
  'wizard.summary.edit': 'Edita',
  'wizard.summary.brand.none': "Els d'Eklevo",
  'wizard.summary.logo.none': "El d'Eklevo",
  'wizard.summary.none': 'Sense indicar',
  'wizard.summary.people': 'Les carrega RRHH des de la seva consola, amb la plantilla.',
  'wizard.summary.notice.url': 'Enllaç',
  'wizard.summary.notice.text':
    '{count, plural, one {Text de # caràcter} other {Text de # caràcters}}',
  'wizard.summary.courses.none': 'Cap: es podran activar després, des de «Cursos».',
  'wizard.summary.invitations':
    "{count, plural, one {En crear-la, la persona de l'equip de RRHH rebrà la invitació.} other {En crear-la, les # persones de l'equip de RRHH rebran la invitació.}}",
  'wizard.create': "Crea l'empresa",
  'wizard.create.busy': "Creant l'empresa…",
  'wizard.create.purpose': "Crear l'empresa {company}.",
  'wizard.error.required': 'Falta aquesta dada.',
  'wizard.error.field': 'Revisa aquesta dada.',
  'wizard.error.choice': 'Tria una de les opcions.',
  'wizard.error.name.too-short': 'Escriu almenys 2 caràcters.',
  'wizard.error.name.too-long': 'Com a molt, 120 caràcters.',
  'wizard.error.name.taken':
    'Ja hi ha una empresa amb aquest nom, també entre les donades de baixa. Tria-ne un altre.',
  'wizard.error.line.invalid-characters':
    'Té salts de línia o caràcters invisibles que no es poden fer servir.',
  'wizard.error.color.invalid': 'Escriu un color en format #RRGGBB, com #1b2a4a.',
  'wizard.error.color.contrast':
    "Amb l'altre color, no compleix una regla de contrast: mira la llista de sota.",
  'wizard.error.person.too-long': 'Com a molt, 100 caràcters.',
  'wizard.error.email.invalid': 'Escriu un correu vàlid.',
  'wizard.error.email.generic-mailbox':
    "És una bústia compartida. Escriu el correu d'una persona concreta.",
  'wizard.error.email.duplicate': "Aquest correu ja és a l'equip.",
  'wizard.error.legalName.too-long': 'Com a molt, 200 caràcters.',
  'wizard.error.address.too-long': 'Com a molt, 300 caràcters.',
  'wizard.error.taxId.invalid': "No té el format d'un CIF, NIF, NIE o NIF-IVA.",
  'wizard.error.taxId.taken':
    'Ja hi ha una empresa amb aquest CIF/NIF, també entre les donades de baixa.',
  'wizard.error.hr.required': 'Afegeix almenys una persona.',
  'wizard.error.hr.too-many':
    "Com a molt, 10 persones. La resta s'afegeixen després, des de la consola de RRHH.",
  'wizard.error.notice.missing': "Falta l'avís en l'idioma de l'empresa.",
  'wizard.error.notice.url': 'Escriu una adreça que comenci per https://.',
  'wizard.error.notice.too-short': 'Escriu almenys 20 caràcters.',
  'wizard.error.notice.too-long': 'Com a molt, 20.000 caràcters.',
  'wizard.error.notice.invalid-characters': 'Té caràcters invisibles que no es poden fer servir.',
  'wizard.error.notice.placeholder':
    'Aquest text encara té marcadors del model sense omplir: {placeholders}.',
  'wizard.error.courses.too-many': 'Com a molt, 50 cursos.',
  'wizard.error.course.not-available':
    "Aquest curs ja no es pot activar: treu-lo per crear l'empresa.",
  'wizard.error.logo.uploading': 'Espera que acabi la pujada del logotip, o cancel·la-la.',
  'wizard.error.logo.scanning':
    "Encara s'està revisant el logotip. Espera un moment i torna-ho a provar.",
  'wizard.error.logo.too-large': 'El logotip supera 1 MB.',
  'wizard.error.logo.empty': 'El fitxer és buit.',
  'wizard.error.logo.wrong-type': 'El logotip ha de ser una imatge PNG o JPEG.',
  'wizard.error.logo.wrong-dimensions': 'El logotip ha de fer entre 32 i 4.000 píxels per costat.',
  'wizard.error.logo.infected':
    "La revisió de seguretat ha trobat un problema al fitxer, i no s'ha pujat.",
  'wizard.error.logo.scan-failed': "No s'ha pogut revisar el fitxer. Prova-ho amb un altre.",
  'wizard.error.logo.missing': 'El fitxer no ha arribat sencer. Torna a pujar-lo.',
  'wizard.error.logo.expired': 'La pujada del logotip ha caducat. Torna a pujar-lo.',
  'wizard.error.logo.network': "S'ha perdut la connexió mentre es pujava. Torna a pujar-lo.",
  'wizard.error.logo.scan-timeout': 'La revisió del fitxer tarda massa. Torna a pujar-lo més tard.',
  'wizard.error.logo.failed': "No s'ha pogut pujar el logotip. Torna-ho a provar.",
  'wizard.error.rateLimited':
    'Has fet massa intents de crear empreses. Espera una estona i torna-ho a provar: el que has escrit continua aquí mentre no tanquis la pestanya.',
  'wizard.error.generic':
    "No s'ha pogut crear l'empresa. Torna-ho a provar d'aquí a uns minuts: el que has escrit continua aquí.",
  'reauth.title': 'Confirma que ets tu',
  'reauth.body':
    "Aquesta acció necessita la teva clau d'accés: l'empremta, la cara o el PIN del dispositiu.",
  'reauth.confirm': "Fes servir la meva clau d'accés",
  'reauth.busy': "Esperant la teva clau d'accés…",
  'idle.title': 'Encara hi ets?',
  'idle.body':
    'Per seguretat, la sessió es tanca després de 30 minuts sense activitat. Es tancarà a les {at, time, short}.',
  'idle.stay': 'Mantén la sessió',
  'ending.notice':
    'La sessió acaba a les {endsAt, time, short}, quan arriba a les 8 hores. Després hauràs de tornar a entrar.',
} as const satisfies BackOfficeCatalog
